import useSWR from 'swr';
import { paxios } from 'util/axiosprgs';

export type CtgryMppngInfoRes = {
  ctgryGrpId: number;
  ctgryId: number;
  lang: string;
};

export const useSwrCtgryMppng = (
  ctgryIds: number[]
): {
  data?: CtgryMppngInfoRes[];
} => {
  const { data } = useSWR<CtgryMppngInfoRes[]>(
    ctgryIds?.length > 0 && ['/api/guest/zdata/ctgrymppng/getCtgryMppngInfos', { ctgryIds }]
  );

  return {
    data,
  };
};

export const useApiCtgryMppng = (): ((ctgryIds: number[]) => Promise<CtgryMppngInfoRes[]>) => {
  // /guest/zdata/ctgrymppng/getCtgryMppngInfos
  const api = (ctgryIds: number[]): Promise<CtgryMppngInfoRes[]> => {
    if (ctgryIds.length === 0) {
      return Promise.resolve([]);
    }
    const params = new URLSearchParams();
    ctgryIds.forEach((id) => params.append('ctgryIds', id.toString()));

    return paxios
      .get<CtgryMppngInfoRes[]>(`/api/guest/zdata/ctgrymppng/getCtgryMppngInfos`, { params })
      .then((res) => res.data);
  };

  return api;
};
